module.exports = __webpack_public_path__ + "img/download-icon.c6c706b2.svg";